import { PROMISE_RESOLVE_VOID as t, promiseWait as e, errorToPlainJson as n } from "rxdb-old2";
var r = new Map();
export var RX_STORAGE_NAME_SQLITE = "sqlite";
export var SQLITE_VARIABLES_LIMIT = 999;
export function attachmentRowKey(t, e) {
  return t + "||" + e;
}
export function getDatabaseConnection(t, e) {
  var n = r.get(e);
  if (n) {
    if (n.sqliteBasics !== t) throw new Error("opened db with different creator method " + e);
    n.openConnections = n.openConnections + 1;
  } else n = {
    database: t.open(e).then(async e => (t.journalMode && (await t.setPragma(e, "journal_mode", t.journalMode)), e)),
    sqliteBasics: t,
    openConnections: 1
  }, r.set(e, n);
  return n.database;
}
export async function closeDatabaseConnection(t, e) {
  var n = r.get(t);
  if (n && (n.openConnections = n.openConnections - 1, 0 === n.openConnections)) return r.delete(t), n.database.then(t => e.close(t));
}
export function getIndexId(t) {
  return "rxdb_" + t.map(t => t.replace(/\./g, "_dot_")).join("_") + "_idx";
}
export function getSQLiteInsertSQL(t, e, n) {
  return {
    query: "\n        INSERT INTO " + t + "(\n            id,\n            revision,\n            deleted,\n            lastWriteTime,\n            data\n        ) VALUES (\n            ?,\n            ?,\n            ?,\n            ?,\n            json(?)\n        );\n    ",
    params: [n[e], n._rev, n._deleted ? 1 : 0, n._meta.lwt, JSON.stringify(n)],
    context: {
      method: "getSQLiteInsertSQL",
      data: {
        collectionName: t,
        primaryPath: e
      }
    }
  };
}
export function getSQLiteUpdateSQL(t, e, n) {
  var r = n.document;
  return {
    query: '\n    UPDATE "' + t + '"\n    SET \n        revision = ?,\n        deleted = ?,\n        lastWriteTime = ?,\n        data = json(?)\n    WHERE\n        id = ?\n    ',
    params: [r._rev, r._deleted ? 1 : 0, r._meta.lwt, JSON.stringify(r), r[e]],
    context: {
      method: "getSQLiteUpdateSQL",
      data: {
        tableName: t,
        primaryPath: e
      }
    }
  };
}
export function getJsonExtract(t, e) {
  return t === e ? "id" : "JSON_EXTRACT(data, '$." + e + "')";
}
export function getSQLiteFindByIdSQL(t, e, n) {
  var r = n ? "" : " AND deleted = 0";
  return {
    query: '\n        SELECT * FROM "' + t + '"\n        WHERE id IN (' + new Array(e.length).fill(PARAM_KEY).join(", ") + ")\n        " + r + ";\n    ",
    params: e,
    context: {
      method: "getSQLiteFindByIdSQL",
      data: {
        tableName: t,
        docIds: e
      }
    }
  };
}
export function isPlainObject(t) {
  return "object" == typeof t && t.constructor == Object;
}
var o = new WeakMap();
export async function sqliteTransaction(e, n, r, a) {
  var i = o.get(e);
  return i || (i = t), i = i.then(async () => {
    await openSqliteTransaction(e, n);
    var t = await r();
    await finishSqliteTransaction(e, n, t, a);
  }), o.set(e, i), i;
}
export async function openSqliteTransaction(t, r) {
  for (var o = !1; !o;) try {
    await r.run(t, {
      query: "BEGIN;",
      params: [],
      context: {
        method: "openSqliteTransaction",
        data: ""
      }
    }), o = !0;
  } catch (t) {
    console.log("open transaction error (will retry):"), console.log(JSON.stringify(n(t))), console.dir(t), await e(0);
  }
}
export function finishSqliteTransaction(t, e, n, r) {
  return e.run(t, {
    query: n + ";",
    params: [],
    context: {
      method: "finishSqliteTransaction",
      data: n
    }
  }).catch(t => {
    throw r && (console.error("cannot close transaction (mode: " + n + ")"), console.log(JSON.stringify(r, null, 4))), t;
  });
}
export var PARAM_KEY = "?";
export function ensureParamsCountIsCorrect(t) {
  if (t.params.length !== t.query.split(PARAM_KEY).length - 1) throw new Error("ensureParamsCountIsCorrect() wrong param count: " + JSON.stringify(t));
}